/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Account_Status_Active_VerifiedInputs */



/**
* | output |
* | --- |
* | "Active & Verified" |
*
* @param {Profile_Account_Status_Active_VerifiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_account_status_active_verified = /** @type {((inputs?: Profile_Account_Status_Active_VerifiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Account_Status_Active_VerifiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktiv und verifiziert")
	return /** @type {LocalizedString} */ ("Active & Verified")
});